import { BaseModal } from "../BaseModal";
import { ConsentModalHeader } from "./ConsentModalHeader";
import { ConsentModalFooter } from "./ConsentModalFooter";
import { ContentModalContent } from "./ConsentModalContent";
import clsx from "clsx";
import "./ConsentModal.scss";

type ConsentModalProps = {
  open: boolean;
  overrideClassNames?: string;
  setOpen: (open: boolean) => void;
  children: React.ReactNode;
};

const ConsentModal = ({
  open,
  overrideClassNames,
  setOpen,
  children,
}: ConsentModalProps) => {
  return (
    <BaseModal
      open={open}
      setOpen={setOpen}
      overrideClassNames={clsx("ui-consent-modal-override", overrideClassNames)}
    >
      {children}
    </BaseModal>
  );
};

ConsentModal.Header = ConsentModalHeader;
ConsentModal.Content = ContentModalContent;
ConsentModal.Footer = ConsentModalFooter;

export { ConsentModal };
